import SummaryView from '@/SummaryViews/SummaryView';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import SummaryViewTuple from '@/SummaryViews/SummaryViewTuple';

export default abstract class AsyncSummaryView extends SummaryView implements IAsyncElementProvider, IAsyncTupleProvider<SummaryViewTuple> {
    protected constructor() {
        super();
    }

    public getSummaryView(): JQuery {
        throw new Error("'getSummaryView' is not supported in 'AsyncSummaryView'");
    }

    public async getTupleAsync(): Promise<SummaryViewTuple> {
        if (this.tuple)
            return this.tuple;

        const $view = await this.getElementAsync();
        this.tuple = new SummaryViewTuple(this, $view);
        return this.tuple;
    }

    public abstract getElementAsync(): Promise<JQuery>;
}